import { Pipe, PipeTransform } from '@angular/core';
import { MessageService } from 'primeng/api';

@Pipe({
  name: 'filterByFormControlType'
})
export class FilterByFormControlTypePipe implements PipeTransform {
  constructor(private messageService: MessageService){}
  transform(
    columns: any[],
    formControlType: any,
    isSavedSearch: boolean
  ): any[] {
    if (!formControlType || !columns) return [];
    let value:string= formControlType.formControl?.type ? formControlType.formControl.type : formControlType.formControl; 
 

    const availableGroup = [
      ['InputBox', 'Email', 'Phone'],
      ['DropDownList', 'RadioButton'],
      ['MultipleDropDownList', 'CheckBox'],
      ['Number', 'Rating'],
      ['ToggleButton']
    ];

    let selectedGroup = availableGroup
      .map(group => group.find(control => control === value))
      .filter(Boolean); // Remove undefined values

      if (selectedGroup.length === 0) {
        selectedGroup.push(value)
      }
      const filteredColumns=  columns.filter(col =>
        selectedGroup.includes(isSavedSearch ? col.formControlType : col.formControlName)
      );
      if (filteredColumns.length === 0) {
        const perspective = isSavedSearch ? 'Saved Search Columns' : 'Workbook Columns';
        this.messageService.add({ 
          severity: 'info', 
          summary: 'No Matching Columns', 
          detail: `No ${perspective} are available for the selected module fields. Please check the data types of the selected module fields and ensure that matching data type fields exist in the ${perspective.toLowerCase()}.` 
        });
      }
    return filteredColumns;
  }

}
